import { z } from "zod";

// Bucket 8 — admin submissions accept/decline. Replaces
// /app/admin/submissions/_actions.ts.
//
// Accept takes no body. Decline takes an optional free-text reason that
// lands on form_submissions.decision_note and is included in the partner
// notification email.

export const declineSubmissionRequestSchema = z.object({
  note: z.string().max(2000).optional(),
});
export type DeclineSubmissionRequest = z.infer<
  typeof declineSubmissionRequestSchema
>;
